import { config } from 'env_def';
import { inWindow } from '@/config';
const contextPath = config('contextPath');
class LocationHelperImpl {
    buildStaticUrl(path, hash, param) {
        let paramStr = '';
        let hashStr = '';
        const urlPath = contextPath + path;
        if (param && param.size > 0) {
            paramStr = '?' + this.buildUrlParamFromMap(param);
        }
        if (hash && hash.size > 0) {
            hashStr = '#' + this.buildUrlParamFromMap(hash);
        }
        return urlPath + paramStr + hashStr;
    }
    testPathMatch(key, matchExactly, location) {
        if (!inWindow())
            return false;
        const loc = location || window.location;
        const urlPath = loc.pathname.replace(contextPath, '').replace(/index\.html$/i, '');
        if (key === '/') {
            return urlPath === '/';
        }
        return matchExactly ? urlPath === key : urlPath.indexOf(key) >= 0;
    }
    testPathMatchBoundary(key, location) {
        if (!inWindow())
            return false;
        const loc = location || window.location;
        const urlPath = loc.pathname.replace(contextPath, '').replace(/index\.html$/i, '');
        if (key === '/') {
            return urlPath === '/';
        }
        const reg = new RegExp(`/\b${key}\b/`);
        return reg.test(urlPath);
    }
    testHrefMatch(key, matchExactly, location) {
        if (!inWindow())
            return false;
        const loc = location || window.location;
        return matchExactly ? loc.href === key : loc.href.indexOf(key) >= 0;
    }
    buildUrlParamFromMap(param) {
        let result = '';
        param.forEach((k, v) => {
            result += k + '=' + encodeURIComponent(v) + '&';
        });
        return result;
    }
    getParam(key) {
        if (!inWindow())
            return undefined;
        const queryString = window.location.search.substring(1);
        if (!queryString)
            return undefined;
        return this.parseQueryString(queryString, key);
    }
    parseQueryString(queryString, key) {
        if (typeof URLSearchParams !== 'undefined') {
            return this.parseWithURLSearchParams(queryString, key);
        }
        return this.parseManually(queryString, key);
    }
    parseWithURLSearchParams(queryString, key) {
        const search = new URLSearchParams(queryString);
        const value = search.get(key);
        return value || undefined;
    }
    parseManually(queryString, key) {
        const params = queryString.split('&');
        for (const param of params) {
            const [paramKey, ...rest] = param.split('=');
            if (paramKey === key) {
                return rest.length > 0 ? this.safeDecode(rest.join('=')) : '';
            }
        }
        return undefined;
    }
    safeDecode(value) {
        if (!value)
            return value;
        try {
            return decodeURIComponent(value);
        }
        catch (_a) {
            return undefined;
        }
    }
    getHost() {
        if (!inWindow())
            return '';
        return window.location.host;
    }
    getHash() {
        if (inWindow()) {
            const routeWithoutHash = window.location.hash.replace(/^#/, '');
            if (routeWithoutHash)
                return window.encodeURIComponent(routeWithoutHash);
        }
        return undefined;
    }
    getSessioNameByUrl(url, sessionKey = '_session') {
        const DEFAULT_SESSION = '';
        try {
            if (!url || !url.length)
                return DEFAULT_SESSION;
            const urlObj = new URL(url);
            if (urlObj.search) {
                const params = new URLSearchParams(urlObj.search);
                if (params.has(sessionKey)) {
                    return params.get(sessionKey) || DEFAULT_SESSION;
                }
            }
            return DEFAULT_SESSION;
        }
        catch (ex) {
            return DEFAULT_SESSION;
        }
    }
    getProtocol() {
        if (!inWindow())
            return '';
        return window.location.protocol + '//';
    }
    isMainPage() {
        return this.testPathMatch('/');
    }
    isBkPage() {
        return this.testPathMatch('/api_data_init');
    }
    isReadMail() {
        return this.testPathMatch('/readMail/');
    }
    isJumpPage() {
        return this.testPathMatch('/jump');
    }
    isFrontPage() {
        if (!inWindow()) {
            return false;
        }
        return !window.isBridgeWorker;
    }
}
export const locationHelper = new LocationHelperImpl();
